import React, { useState } from 'react';
import { Sidebar } from './Sidebar';
import { Recipies } from './Recipies';
import { Products } from './Products';
import { Ingredients } from './Ingredients';
import { Commands } from './Commands';
import { Run } from './Run';
import { CustomProduction } from './CustomProduction';
import { Import } from './Import';

const pageMeta = {
    products: { title: 'Διαχείριση Προϊόντων', icon: 'bi-box-seam', desc: 'Κατάλογος τελικών προϊόντων και προδιαγραφών' },
    ingredients: { title: 'Διαχείριση Συστατικών', icon: 'bi-pie-chart-fill', desc: 'Πρώτες ύλες και συστατικά παραγωγής' },
    recipies: { title: 'Συνταγολόγιο', icon: 'bi-journal-bookmark-fill', desc: 'Σύνθεση συνταγών και αναλογίες συστατικών' },
    commands: { title: 'Εντολές Παραγωγής', icon: 'bi-clipboard2-check-fill', desc: 'Προγραμματισμός και παρακολούθηση εντολών' },
    execute: { title: 'Εκτέλεση Συνταγής & Ζύγιση', icon: 'bi-play-circle-fill', desc: 'Ζωντανή ζύγιση, βήματα εκτέλεσης και καταγραφή' },
    production: { title: 'Custom Παραγωγή', icon: 'bi-gear-wide-connected', desc: 'Εκτέλεση συνταγής με προσαρμοσμένη ποσότητα' },
    import: { title: 'Εισαγωγή Δεδομένων', icon: 'bi-database-fill-up', desc: 'Μεταφορά και συγχρονισμός δεδομένων' },
};

const getInitialPage = () => {
    try {
        const hasActiveRun = localStorage.getItem('microprod_active_run');
        if (hasActiveRun) return 'execute';
        const hasActiveCustom = localStorage.getItem('microprod_active_custom_production');
        if (hasActiveCustom) return 'production';
        const savedPage = localStorage.getItem('dashboard_active_page');
        if (savedPage && pageMeta[savedPage]) return savedPage;
    } catch (e) {
        console.error('Error reading initial page from localStorage:', e);
    }
    return 'products';
};

const Dashboard = () => {
    const [page, setPageState] = useState(getInitialPage);
    const currentMeta = pageMeta[page] || pageMeta.products;

    const setPage = (newPage) => {
        setPageState(newPage);
        try {
            localStorage.setItem('dashboard_active_page', newPage);
        } catch (e) {
            console.error('Error saving active page to localStorage:', e);
        }
    };

    return (
        <div className="app-layout">
            <Sidebar page={page} setPage={setPage} />
            <div className="app-main">
                <header className="ek-topbar">
                    <div className="ek-topbar-title">
                        <i className={`bi ${currentMeta.icon}`} style={{ fontSize: '1.4rem', color: 'var(--brand-accent)' }}></i>
                        <div>
                            <h2>{currentMeta.title}</h2>
                            <small style={{ color: 'var(--brand-gray)', fontSize: '0.8rem' }}>{currentMeta.desc}</small>
                        </div>
                    </div>
                    <div className="ek-topbar-actions">
                        <span className="ek-topbar-badge">
                            <i className="bi bi-shield-check me-1"></i> Axion MES v1.0
                        </span>
                    </div>
                </header>

                <main className="app-content">
                    {page === 'products' && <Products />}
                    {page === 'ingredients' && <Ingredients />}
                    {page === 'recipies' && <Recipies />}
                    {page === 'commands' && <Commands />}
                    {page === 'execute' && <Run />}
                    {page === 'production' && <CustomProduction />}
                    {page === 'import' && <Import />}
                </main>
            </div>
        </div>
    );
};

export { Dashboard };
export default Dashboard;
